// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__XtdWp","errorLogs":"EditorFooter_errorLogs__2sO5f"};